import { nameColumn } from "../../../../layouts/Table/columns/nameColumn";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useCallback, useMemo, useState } from "react";
import { Avatar, Flex, Group } from "@mantine/core";
import MainTable from "../../../../layouts/Table/MainTable";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { useListingLoader } from "../../../../components/hooks/ListingHooks";
import { IconChevronDown } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { deletePool, editPool, getPools } from "../../../../api/EmailAPI";
import dateColumn from "../../../../layouts/Table/columns/dateColumn";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import { sharingColumn } from "../../../../layouts/Table/columns/sharingColumn";

const PoolsListing = ({ type = "Email", loading, setLoading }) => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiRef();

  const columns = useMemo(() => {
    return [
      nameColumn({
        headerName: "Nom",
        disableLink: true,
        editFunction: () => editPool,
        width: 316,
        apiRef,
        leftSection: function (row) {
          return (
            <Avatar
              color="initials"
              name={row.name}
              radius={"md"}
              size={36}
              variant="filled"
            />
          );
        },
      }),
      {
        field: "accounts_list",
        headerName: lang.new_senders.accounts,
        width: 200,
        type: "number",
        align: "left",
        headerAlign: "left",
        valueGetter: ({ value }) => value.length,
      },
      sharingColumn({ apiRef, editFunction: () => editPool }),
      dateColumn(),
    ];
  }, [apiRef]);

  const [rows, setRows] = useState([]);

  const actionsCell = useCallback(
    ({ row }) => {
      return (
        <Group wrap="nowrap" gap={8}>
          <ItemDeleter
            title_bold={`${row.name} #${row.id}`}
            handleDelete={deletePool}
            deletedMessage={lang.pools.delete_success}
            id={row.id}
            apiRef={apiRef}
          />

          <IconChevronDown size={24} opacity={0.4} />
        </Group>
      );
    },
    [apiRef, lang.pools.delete_success]
  );

  const navigate = useNavigate();
  const handleRowClick = ({ row }) => {
    navigate(`/senders/pool/${row.id}/${type.toLowerCase()}/none`);
  };

  useListingLoader({
    loading,
    setLoading,
    listGetter: getPools,
    responseField: "pools_list",
    setRows,
    getRows: (result) => result.filter((x) => x.type === type),
  });

  return (
    <Flex w={"100%"} pos={"relative"} flex={1}>
      <MainTable
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        loading={loading}
        setLoading={setLoading}
        id={"list-table"}
        actionsCell={actionsCell}
        hasFolder
        disableCheckboxes={true}
        actionsCellWidth={75}
        disableGotoPage
        disableVisibleColumns
        defaultPerPage={15}
        disablePerPage
        onRowClick={handleRowClick}
        whiteButtons
        tableSx={{
          "& .MuiDataGrid-columnHeaders": {
            border: "none !important",
          },
          "& .MuiDataGrid-pinnedColumnHeaders": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-pinnedColumns": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-cell": {
            border: "none !important",
            borderRadius: 8,
          },
          "& .MuiDataGrid-main": {
            border: "none !important",
            borderRadius: "0 !important",
            background: "none !important",
          },
          "& .table-row": {
            cursor: "pointer",
            borderRadius: 4,
            marginBottom: 1,
            background: "#fff !important",
            border: "1px solid var(--mantine-color-primary-1)",
          },
          "& .MuiDataGrid-pinnedColumns--right .table-row": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "none",
          },
          "& .MuiDataGrid-pinnedColumns--left .table-row": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: "none",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone .table-row": {
            borderRadius: 3,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden",
          },
          "& .MuiPagination-root": {
            left: 0,
            transform: "none",
          },
          "& .Mui-selected": {
            color: "",
          },
          "& .MuiDataGrid-footerContainer": {
            border: 0,
          },
        }}
      />
    </Flex>
  );
};

export default PoolsListing;
